var map = {
	"./01_quote_desktop.jpg": 805,
	"./01_quote_mobile.jpg": 806,
	"./01_quote_tablet.jpg": 807,
	"./02_quote_desktop.jpg": 808,
	"./02_quote_mobile.jpg": 809,
	"./02_quote_tablet.jpg": 810,
	"./03_quote_desktop.jpg": 811,
	"./03_quote_mobile.jpg": 812,
	"./03_quote_tablet.jpg": 813,
	"./04_quote_desktop.jpg": 814,
	"./04_quote_mobile.jpg": 815,
	"./04_quote_tablet.jpg": 816,
	"./2A9JHW6.crop.jpg": 817,
	"./2BWDCE1.crop.jpg": 818,
	"./8_IMAGE_2-WAKAME-desktop.jpg": 819,
	"./8_IMAGE_3-PHOTOBIOREACTOR-desktop.jpg": 820,
	"./8_IMAGE_4-SOYBEAN-desktop.jpg": 821,
	"./8_IMAGE_5-SPIRULINA-desktop.jpg": 822,
	"./Amah_desktop_article_7.jpg": 823,
	"./Apple-Packer-Robotics-Plus.jpg": 824,
	"./Cindy_Ayres_Foot_Print.jpg": 825,
	"./DPBX9A.crop.jpg": 826,
	"./Doh.crop.jpg": 827,
	"./Edith_desktop_article_7.jpg": 828,
	"./Ediths_plot_desktop_article_7.jpg": 829,
	"./Founders-Robotics-Plus.jpg": 830,
	"./IMAGE-2-CHESTNUTS-desktop.jpg": 831,
	"./IMAGE-2-PLASTIC-MULCH-desktop.jpg": 832,
	"./IMAGE-3-DEFORESTATION-desktop.jpg": 833,
	"./IMAGE-3-GREEN-BEANS-desktop.jpg": 834,
	"./IMAGE-4-FOREST-FLOOR-desktop.jpg": 835,
	"./IMAGE-4-SILAGE-PLASTIC-desktop.jpg": 836,
	"./IMAGE-5-CHICKENS-desktop.jpg": 837,
	"./IMAGE-5-MILK-BOTTLES-desktop.jpg": 838,
	"./IMAGE_2-BEE_HIVE_(GETTY)_desktop.jpg": 839,
	"./IMAGE_3-ALMONDS_(GETTY)_desktop.jpg": 840,
	"./IMAGE_4-BEE_TRUCK_(Peter_Nelson)_desktop.jpg": 841,
	"./IMAGE_5-ARIEL_FARM_(GETTY)_desktop.jpg": 842,
	"./IMAGE_6-WILDFLOWER_(GETTY)_desktop.jpg": 843,
	"./Image_2_carpark_Cycloponics.jpg": 844,
	"./James-wong-Barton-Farm.jpg": 845,
	"./James-wong-rice-field.jpg": 846,
	"./Lonja0181.crop.jpg": 847,
	"./MJBDKY.crop.jpg": 848,
	"./MRRTCB.crop.jpg": 849,
	"./PJDAEA.crop.jpg": 850,
	"./PRESIDENTE-APV.crop.jpg": 851,
	"./Paoline_desktop_article_7.jpg": 852,
	"./Pods_desktop_article_7.jpg": 853,
	"./Rosine_desktop_article_7.jpg": 854,
	"./Sahara_forest_crop_desktop.jpg": 855,
	"./Sahara_forest_crop_mobile.jpg": 856,
	"./Sahara_forest_crop_tablet.jpg": 857,
	"./Salad-Paul-Marc-Mitchell-Growing-Underground.jpg": 858,
	"./Salimata_desktop_article_7.jpg": 859,
	"./Seawatergreenhouseaus_crop3_desktop.jpg": 860,
	"./Seawatergreenhouseaus_crop3_mobile.jpg": 861,
	"./Seawatergreenhouseaus_crop3_tablet.jpg": 862,
	"./Square_Roots_Basil_Farm.crop.jpg": 863,
	"./Square_Roots_Next-Gen_Farmer_Transplanting_Basil.crop.jpg": 864,
	"./Thought-leaders-basil.jpg": 865,
	"./Thought-leaders-parched-land.jpg": 866,
	"./Thought-leaders-planting-saxal.jpg": 867,
	"./Thought-leaders-rice-field.jpg": 868,
	"./UGV-Robotics-Plus.jpg": 869,
	"./WWII-Tunnel-Growing-Underground.jpg": 870,
	"./Yaoua_desktop_article_7.jpg": 871,
	"./africa_w2.jpg": 872,
	"./aggregates-on-sand-desktop.jpg": 873,
	"./aggregates-on-sand-mobile.jpg": 874,
	"./aggregates-on-sand-tablet.jpg": 875,
	"./application-5-crop-desktop.jpg": 876,
	"./application-5-crop-mobile.jpg": 877,
	"./application-5-crop-tablet.jpg": 878,
	"./application-crop-desktop.jpg": 879,
	"./application-crop-mobile.jpg": 880,
	"./application-crop-tablet.jpg": 881,
	"./catherine_crop.jpg": 882,
	"./cattle-drones-2-for-one-up.jpg": 883,
	"./cattle-drones-cattle.jpg": 884,
	"./cattle-drones-drone-2.jpg": 885,
	"./cattle-drones-from-elvis-credit-REUTERS.jpg": 886,
	"./charts1.jpg": 887,
	"./follow_food_elvis2.jpg": 888,
	"./food-chain-asparagus-pickers-desktop.jpg": 889,
	"./food-chain-asparagus-pickers-mobile.jpg": 890,
	"./food-chain-asparagus-pickers-tablet.jpg": 891,
	"./food-chain-grapes-desktop.jpg": 892,
	"./food-chain-grapes-mobile.jpg": 893,
	"./food-chain-grapes-tablet.jpg": 894,
	"./foood-chain-blockchain-and-robotics-desktop.jpg": 895,
	"./foood-chain-blockchain-and-robotics-mobile.jpg": 896,
	"./foood-chain-blockchain-and-robotics-tablet.jpg": 897,
	"./grain_10.jpg": 898,
	"./grower-at-pale-green-dots-lower-sheering-farm.crop.jpg": 899,
	"./how-we-can-adapt-plants-to-save-our-planet.jpg": 900,
	"./image-crop-22-desktop.jpg": 901,
	"./image-crop-22-mobile.jpg": 902,
	"./image-crop-22-tablet.jpg": 903,
	"./james_wong_article_9.jpg": 904,
	"./mill_10.jpg": 905,
	"./pad-technology_Sahara-Forest-Project-Foundation_crop_desktop.jpg": 906,
	"./pad-technology_Sahara-Forest-Project-Foundation_crop_mobile.jpg": 907,
	"./pad-technology_Sahara-Forest-Project-Foundation_crop_tablet.jpg": 908,
	"./polytunnels-at-sussex.crop.jpg": 909,
	"./renee-hendrix-food-cabinet.jpg": 910,
	"./social-fisherman-11.jpg": 911,
	"./super_market_9.jpg": 912,
	"./the-simple-shellfish-boat.jpg": 913,
	"./the-simple-shellfish-frames.jpg": 914,
	"./the-simple-shellfish-oysters.jpg": 915,
	"./the-simple-shellfish-sea-squirts.jpg": 916,
	"./wind_power_middle_east_desktop.jpg": 917,
	"./wind_power_middle_east_mobile.jpg": 918,
	"./wind_power_middle_east_tablet.jpg": 919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 804;